module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module4-8.137ef542.jpg";